import React from 'react';
import useIcons from '../../../hooks/use-icon';
import styles from './BackButton.module.scss';

const BackButton = ({ icon, onClick }) => {
	const Icon = useIcons(icon);
	return (
		<div className={styles.backbutton_wrapper} onClick={() => onClick()}>
			<Icon />
			<div className={styles.button_text}>Back Reports</div>
		</div>
	);
};

export default BackButton;
